import { defineStore } from 'pinia';
import i18n from '@/plugins/translator/i18nOutsideComponent';
const { t } = i18n.global;

const useAlertStore = defineStore('alert', {
    state: () => ({
        messages: [],
        message: '',
        buttons: [],
        promise: null
    }),
    actions: {
        addMessage(message = t('unexpected_error'), buttons = []) {
            this.messages.push({ message, buttons });
        },

        async show(message, buttons = []) {
            if (typeof message !== 'string') {
                message =
                    typeof message === 'object' && message.message
                        ? message.message
                        : t('Unexpected warning message format');
            }

            return new Promise((resolve) => {
                this.message = message;
                this.buttons = buttons;
                this.promise = resolve;
            });
        },

        close() {
            this.promise(true);
            this.message = '';
            this.buttons = [];
            this.promise = null;
        }
    }
});

export default useAlertStore;
